<template>
  <div class="content">
    <div class="inner_content">
      <div class="header">
        <div class="flex">
          <el-button type="primary" size="small" @click="addSlice"
            >添加节日有礼</el-button
          >
          <div class="box flex">
            <div class="title">活动状态：</div>
            <el-select
              v-model="value"
              placeholder="请选择"
              size="small"
              class="fixedwidth"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="box flex">
            <div class="title"></div>
            <el-input
              class="fixedwidth"
              size="small"
              placeholder="请输入活动名称"
            ></el-input>
            <el-button size="small" type="primary" placeholder="请输入活动名称"
              >查询</el-button
            >
          </div>
        </div>
      </div>
      <template>
        <el-table :data="tableData" size="small" :header-cell-style="setHeader">
          <el-table-column
            prop="sort"
            label="活动名称"
            width="140"
          ></el-table-column>
          <el-table-column prop="title" label="活动奖品"></el-table-column>
          <el-table-column prop="title" label="活动时间"></el-table-column>
          <el-table-column label="操作人" width="200"> </el-table-column>
        </el-table>
      </template>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      page_id: "",
      tableData: [],
      form: {
        value: true,
        name: "",
        region: ""
      },
      formLabelWidth: "120px",
      dialogFormVisible: false,
      options: [
        {
          value: "0",
          label: "全部状态"
        }
      ],
      value1: "",
      value: "",
      headerStyle: {
        background: "rgba(250,250,250,1)",
        color: "#000000"
      }
    };
  },
  mounted() {
    this.page_id = this.$route.params.id;
  },
  methods: {
    // 设置表头颜色
    setHeader({ rowIndex }) {
      if (rowIndex === 0) {
        return this.headerStyle;
      } else {
        return "";
      }
    },
    addSlice() {
      this.$router.push({
        path: `holiday-set`
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 26px 11px 20px;
  height: calc(100vh - 102px);
  border: 1px solid #f1f1f1;
  overflow: auto;
  min-width: 900px;
  // background:rgba(240,242,245,1);
  .inner_content {
    background: #fff;
    padding: 0 24px;
    height: 100%;
    .header {
      margin-bottom: 20px;
      .box {
        width: 330px;
        .title {
          min-width: 100px;
          text-align: right;
        }
        .fixedwidth {
          width: 180px;
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
}
// 通用样式
.flex {
  display: flex;
  align-items: center;
  padding: 10px 0px;
}
</style>
